<template>
    <div id="RelationshipManagement" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" @keyup.esc="closeModal()">
      <div class="modal-dialog modal-dialog-centered modal-xxl" role="document">
            <div class="modal-content mx-auto">
                <button type="button" class="modal-close" @click="closeModal()" aria-label="Cancel">
                    <i class="fas fa-lg fa-times"></i>
                </button>
                <div class="modal-body">
                    <div class="panel-tab-content">
                        <div class="row">
                            <!-- SIDE NAVIGATION -->
                            <div class="col-xl-2 col-md-3 px-0"
                                :class="{'border-right border-olf-isabelline' :!$breakpoint.smAndDown}">

                          <h3 class="pl-3">{{relationshipProp.name}}</h3>

                                <!-- SIDENAV -->
                                <div class="nav flex-column nav-pills" role="tablist" aria-orientation="vertical">
                                    <div v-for="(nav, idx) in getTabs" :key="idx">
                                        <a class="nav-link" :class="{'active': currentTab.id === nav.id, 'disabled': relationshipNotSetUpBool}"
                                            href="javascript:void(0);" @click="selectNavItem(nav.id)">{{ nav.title }}</a>
                                    </div>
                                </div>
                            </div>

                            <!-- TAB CONTENT -->
                            <div class="tab-content col-xl-10 col-md-9" :class="{'pt-4': $breakpoint.smAndDown}">
                              <component :is="currentTab.component"
                                :key="renderKey"
                                :relationshipProp="relationship"
                                :tabsLength="getTabs.length - 1"
                                :tabIndex="getCurrentTabIndex"
                                @emit-next="next"
                                @emit-back="back"
                                @emit-close="close"
                                @emit-tracked-changes="setTrackedChangesStatus"
                                @reloadRelationshipProp="reloadRelationshipProp"
                                @changingLocationUnsavedChanges="changingLocationUnsavedChanges"
                                @deleteLocation="deleteLocation"
                              />
                            <!-- END OF TAB CONTENT -->
                            </div>
                        <!-- END OF ROW -->
                        </div>
                    <!-- END OF PANEL TAB -->
                    </div>
                <!-- END OF MODAL BODY -->
                </div>
            <!-- END OF MODAL CONTENT -->
            </div>
        <!-- END OF MODAL DIALOG -->
        </div>

    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import breakpoint from '@/mixins/index';

import CreditPaymentTerms from '@/components/RelationshipManagement/CreditPaymentTerms.vue'
import OfferRestrictions from '@/components/RelationshipManagement/OfferRestrictions.vue'
import PriceAdjustment from '@/components/RelationshipManagement/PriceAdjustment.vue'
import DeliveryLocation from '@/components/DeliveryLocations/CreateNewDeliveryLocation.vue'

import { getRelationship } from '@/api/relationships.js'

const CREDIT_PAYMENT_TERMS = 'CREDIT_PAYMENT_TERMS';
const OFFER_RESTRICTIONS = 'OFFER_RESTRICTIONS';
const PRICE_ADJUSTMENT = 'PRICE_ADJUSTMENT';
const DELIVERY_LOCATIONS = 'DELIVERY_LOCATIONS';

export default {
    data(){
      return {
          isChangingLocationWithUnsavedChanges: false,
          isDeletingLocation: false,
          renderKey: 0,
          currentTab: {},
          tabs:[
          {
            id: CREDIT_PAYMENT_TERMS,
            title: 'Credit & Payment Terms',
            component: "credit-payment-terms",
          },
          {
            id: OFFER_RESTRICTIONS,
            title: 'Offer Restrictions',
            component: "offer-restrictions"
          },
          {
            id: DELIVERY_LOCATIONS,
            title: 'Delivery Locations',
            component: "delivery-location",
          },
          {
            id: PRICE_ADJUSTMENT,
            title: 'Price Adjustment',
            component: "price-adjustment",
          }
          ],
          CREDIT_PAYMENT_TERMS: CREDIT_PAYMENT_TERMS,
          OFFER_RESTRICTIONS: OFFER_RESTRICTIONS,
          PRICE_ADJUSTMENT: PRICE_ADJUSTMENT,
          DELIVERY_LOCATIONS: DELIVERY_LOCATIONS,
          relationship: {},
          unsavedChangesFound: false,
          targetTabId: ""
        }
    },
    props: ['relationshipProp'],
    components: {
      CreditPaymentTerms,
      OfferRestrictions,
      PriceAdjustment,
      DeliveryLocation
    },
    mixins:[breakpoint],
    created(){
      this.relationship = this.relationshipProp;
      if(this.isPricingEngineEnabled)
        this.tabs = this.tabs.filter(({id}) => id !== PRICE_ADJUSTMENT);
      this.currentTab = this.tabs[0];
    },
    mounted(){
      $('#RelationshipManagement').modal({ backdrop: 'static', keyboard: false });
    },
    computed: {
      ...mapGetters('itemRemoval', ['unsavedChangesRemovalConfirmed', 'showItemRemovalConfirmation']),
      ...mapGetters('login', ['isPricingEngineEnabled']),
      getCurrentTabIndex() {
        return this.getTabs.findIndex(x => x.id === this.currentTab.id);
      },
      getTabs() {
        return this.tabs
      },
      relationshipNotSetUpBool:{
        get: function(){
          if(!this.relationship)
            return true;
          const { days, limit } = this.relationship.credit;
          return !(Number.isInteger(days) && limit);
        }
      }
    },
    watch: {
      showItemRemovalConfirmation(newValue) {
        if (!newValue && this.isDeletingLocation) {
          $(this.$el).modal("show");
          this.isDeletingLocation = false;
        }
      },
      unsavedChangesRemovalConfirmed: {
        handler(isConfirmed){
          if (this.isChangingLocationWithUnsavedChanges) {
            $('#RelationshipManagement').modal({ backdrop: 'static', keyboard: false });
          } else {
            if (isConfirmed){ // User has confirmed to discard unsaved changes
              if (!this.targetTabId){ // We can now close the modal
                this.closeModal(true);
              } else { // Now we can go to the target tab
                this.selectNavItem(this.targetTabId, true);
                $('#RelationshipManagement').modal({ backdrop: 'static', keyboard: false });
              }
            }
          }
          this.isChangingLocationWithUnsavedChanges = false
        }
      }
    },
    methods: {
      changingLocationUnsavedChanges(value) {
        this.isChangingLocationWithUnsavedChanges = value;
        this.showUnsavedChangesConfirmationModal();
      },
      deleteLocation(location) {
        this.isDeletingLocation = true
        $(this.$el).modal("hide");
        const payload = {
          item: location,
          type: "LOCATION",
          showWindow: true
        };
        this.$store.dispatch("itemRemoval/openConfirmationRemoval", payload);
        setTimeout(() => {
          const el = this.$parent.$root.$refs.confirmationRemoveItem.$el;
          $(el).modal({ backdrop: 'static', keyboard: false });
        }, 500);
      },
        async reloadRelationshipProp() {
          this.relationship = await getRelationship(this.relationshipProp.relationshipId);
          this.renderKey++;
        },
        closeModal(isActionConfirmed){
          this.targetTabId = ""; // Reset value to indicate that user is attempting to close the modal

          if (!isActionConfirmed && this.unsavedChangesFound){ // There are unsaved changes to confirm
            this.showUnsavedChangesConfirmationModal();
          } else { // User has either confirmed to discard unsaved changes/there are none, so close the modal
            this.$store.dispatch("itemRemoval/confirmUnsavedChangesRemoval", false);
            $('#RelationshipManagement').modal('hide');
            this.$emit('hideRelationshipManagement');
          }
        },
        async selectNavItem(selectedId, isActionConfirmed){
          if (selectedId === this.currentTab.id){ // For some reason user is selecting the current tab, no need to do anything
            return;
          } else if (!isActionConfirmed && this.unsavedChangesFound){ // There are unsaved changes to confirm
            this.targetTabId = selectedId;
            this.showUnsavedChangesConfirmationModal();
          } else { // User has either confirmed to discard unsaved changes/there are none, so go to the target tab
            this.relationship = await getRelationship(this.relationshipProp.relationshipId);
            this.currentTab = this.tabs.find(({id}) => selectedId === id);
            this.$store.dispatch("itemRemoval/confirmUnsavedChangesRemoval", false);
          }
        },
        async close() {
          if (this.unsavedChangesFound){
            this.showUnsavedChangesConfirmationModal();
          } else {
            this.closeModal(true);
          }
        },
        async next(pageNumber){
          const targetTab = this.tabs[pageNumber + 1];
          if (this.unsavedChangesFound){ // There are unsaved changes to confirm
            this.targetTabId = targetTab.id;
            this.showUnsavedChangesConfirmationModal();
          } else if(pageNumber < this.tabs.length - 1){
            if(pageNumber === 0){
              this.relationship = await getRelationship(this.relationshipProp.relationshipId);
            }
            return this.currentTab = this.tabs[pageNumber + 1];
          } else {
            this.closeModal(true);
          }
        },
        async back(pageNumber){
          const targetTab = this.tabs[pageNumber - 1];

          if (this.unsavedChangesFound){ // There are unsaved changes to confirm
            this.targetTabId = targetTab.id;
            this.showUnsavedChangesConfirmationModal();
          } else { // There are no unsaved changes, so we can go to the previous tab
            this.relationship = await getRelationship(this.relationshipProp.relationshipId);
            if(pageNumber > 0)
              this.currentTab = targetTab;
          }
        },
        setTrackedChangesStatus(trackedChangesStatus){
          this.unsavedChangesFound = trackedChangesStatus;
        },
        showUnsavedChangesConfirmationModal(){
          $('#RelationshipManagement').modal('hide'); // Hide current modal

          // Show removal confirmation modal
          const payload = {
            item: {
              priority: this.$store.getters["itemRemoval/eChangesType"].RelationshipManagement,
              parentModal: this
            },
            type: this.$store.getters["itemRemoval/eRemoveItemType"].UnconfirmedChanges,
            showWindow: true
          };
          this.$store.dispatch("itemRemoval/openConfirmationRemoval", payload);
          setTimeout(() => {
            const el = this.$parent.$root.$refs.confirmationRemoveItem.$el;
            $(el).modal({ backdrop: 'static', keyboard: false });
          }, 500);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/_modals.scss";
</style>
